import { Box, Collapse, IconButton, Table, Switch , TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import MaterialAction from "./MaterialAction";
import ListMaterialUnit from "./ListMaterialUnit";
import LoadingPage from "../Include/LoadingPage";
import EmptyData from "../Include/EmptyData";
import { Fragment, useContext, useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useMutation } from "@apollo/client";
import { UPDATE_MATERIAL_IS_USE } from "../../Schema/Material";
import { AuthContext } from "../../Context/AuthContext";

export default function TableViewMainItem({
    loading,
    tableData,  
    refetch,
    paginationData,

}) {

    const { setAlert } = useContext(AuthContext);
    const [expandedRows, setExpandedRows] = useState([]);

    const handleAccordionChange = (index) => {
      const newExpandedRows = [...expandedRows];
      newExpandedRows[index] = !newExpandedRows[index];
      setExpandedRows(newExpandedRows);
    };

    const [updateMaterialIsUse] = useMutation(UPDATE_MATERIAL_IS_USE, {
      onCompleted: ({ updateMaterialIsUse }) => {
        setAlert(true, "success", updateMaterialIsUse?.message);
        refetch()
      },
      onError: (error) => {
        setAlert(true, "error", error?.message);
      },
    });

    const handleUpdateStatus = (id, status) => {
      updateMaterialIsUse({
        variables: { id, isUse: status },
      });
    };


    //================= width Modify ===============
    const [width, setWidth] = useState(window.innerWidth);
    const updateDimensions = () => setWidth(window.innerWidth - 50);
  
    useEffect(() => {
      window.addEventListener("resize", updateDimensions);
      return () => window.removeEventListener("resize", updateDimensions);
    }, []);


    return(        
        <Box className="body-container">
          <TableContainer sx={{ maxWidth: `${width}px` }}>
            <Table className="table" aria-label="simple table" size="small">
              <TableHead className="header-row">
                <TableRow>
                  <TableCell className="header-title-start" width="3%" />
                  <TableCell className="header-title" width="3%">
                    ល.រ
                  </TableCell>
                  <TableCell className="header-title">ឈ្មោភាសាខ្មែរ</TableCell>
                  <TableCell className="header-title" width="10%">
                    តម្លៃ
                  </TableCell>
                  {/* <TableCell className="header-title">ឈ្មោះអង់គ្លេស</TableCell> */}
                  {/* <TableCell className="header-title">ប្រភេទ</TableCell> */}
                  <TableCell className="header-title" width="10%">
                    ផ្នែក
                  </TableCell>
                  <TableCell className="header-title" width="10%">
                    កម្រិតនៃផ្នែក
                  </TableCell>
                  <TableCell className="header-title" width="5%">
                    ក្រុម
                  </TableCell>
                  <TableCell className="header-title" width="5%">
                    ឯកតា
                  </TableCell>
                  <TableCell className="header-title" width="5%">
                    ទំហំ
                  </TableCell>
                  <TableCell className="header-title" width="10%">
                    ចំណាំ
                  </TableCell>
                  <TableCell className="header-title" width="7%" align="right">
                    ស្ថានភាព
                  </TableCell>
                  <TableCell className="header-title-end" width="10%"></TableCell>
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody className="body">
                  <TableRow className="body-row">
                    <TableCell colSpan={12} className="body-cell">
                      <LoadingPage />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <>
                  {tableData?.length === 0 ? (
                    <TableBody className="body">
                      <TableRow className="body-row">
                        <TableCell colSpan={12} className="body-cell">
                          <EmptyData />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : (
                    <TableBody className="body">
                      {tableData?.map((row, index) => (
                        <Fragment key={index}>
                          <TableRow className="body-row">
                            <TableCell className="body-cell">
                              <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => handleAccordionChange(index)}
                              >
                                {expandedRows[index] ? (
                                  <KeyboardArrowUpIcon
                                    sx={{ color: "#00A0DC" }}
                                  />
                                ) : (
                                  <KeyboardArrowDownIcon
                                    sx={{ color: "#00A0DC" }}
                                  />
                                )}
                              </IconButton>
                            </TableCell>
                            <TableCell className="body-cell">
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell
                              className="body-cell"
                              onClick={() => handleAccordionChange(index)}
                            >
                              {row?.materialKhName}
                            </TableCell>
                            <TableCell
                              className="body-cell"
                              onClick={() => handleAccordionChange(index)}
                            >
                              $ {row?.defaultPrice}
                            </TableCell>
                            {/* <TableCell
                              className="body-cell"
                              onClick={() => handleAccordionChange(index)}
                            >
                              {row?.materialEnName}
                            </TableCell> */}
                            {/* <TableCell
                              className="body-cell"
                              onClick={() => handleAccordionChange(index)}
                            >
                              {row?.categoryId?.categoryKhName}
                            </TableCell> */}
                            <TableCell
                              className="body-cell"
                              onClick={() => handleAccordionChange(index)}
                            >
                              {row?.sectionId?.sectionKhName}
                            </TableCell>
                            <TableCell
                              className="body-cell"
                              onClick={() => handleAccordionChange(index)}
                            >
                              {row?.levelSectionId?.levelSectionKhName}
                            </TableCell>
                            <TableCell
                              className="body-cell"
                              onClick={() => handleAccordionChange(index)}
                            >
                              {row?.groupId?.groupKhName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.smallUnitId?.unitKhName}
                            </TableCell>
                            <TableCell
                              className="body-cell"
                              onClick={() => handleAccordionChange(index)}
                            >
                              {row?.sizeId?.sizeKhName}
                            </TableCell>
                            <TableCell
                              className="body-cell"
                              onClick={() => handleAccordionChange(index)}
                            >
                              {row?.remark}
                            </TableCell>
                            <TableCell className="body-cell" align="right">
                              <Switch
                                size="small"
                                checked={row.isUse}
                                onChange={(e) =>
                                  handleUpdateStatus(row?._id, !row?.isUse)
                                }
                              />
                            </TableCell>
                            <TableCell className="body-cell action-cell">
                              <MaterialAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow className="collapse-row">
                            <TableCell
                              className="body-cell"
                              style={{ paddingBottom: 0, paddingTop: 0 }}
                              colSpan={12}
                            >
                              <Collapse
                                in={expandedRows[index]}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Box sx={{ margin: 1 }}>
                                  <Typography>
                                    Detail for {row.name_en}
                                  </Typography>
                                  <Table
                                    className="table"
                                    aria-label="simple table"
                                    size="small"
                                  >
                                    <TableBody>
                                      <ListMaterialUnit materialId={row} />                                      
                                    </TableBody>
                                  </Table>
                                </Box>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        </Fragment>
                      ))}
                    </TableBody>
                  )}
                </>
              )}
            </Table>
          </TableContainer>
        </Box>         
    )
}